import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Spin } from "antd";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Mostrar carga mientras se verifica la autenticación
  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // Redirigir a login si no está autenticado
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  // Mostrar el componente hijo si está autenticado
  return children;
};

export default PrivateRoute;
